import React from 'react';
import { inject, observer } from 'mobx-react';
import './stylesheets/filterNav.scss';

@inject('languageStore', 'gameStore')
@observer
export default class FilterNav extends React.Component {
  constructor() {
    super();
    this.state = {
      categoryId: 'all',
      hostArea: 'all',
      province: 'all',
      lang: '',
      translateCompetition: {
        zh: '比赛种类',
        en: 'Competition'
      },
      translateCountry: {
        zh: '国家',
        en: 'Country'
      },
      translateRegion: {
        zh: '省市及地区',
        en: 'Region'
      }
    };
  }
  componentWillMount() {
    // 设置默认的语言/国家/地区
    this.setState({
      lang: this.props.languageStore.lang,
      ...this.props.gameStore.navState
    });
  }

  // 切换比赛类型
  handleChangeCategory = categoryId => {
    const { gameStore } = this.props;
    // 切换动作
    this.setState({
      categoryId,
      hostArea: 'all',
      province: 'all'
    });
    gameStore.filterGamesCategory(categoryId);
    // 清空URL带的ID数据
    this.props.gameStore.currentGameId && this.props.gameStore.clearCurrentGameId();
  };

  // 切换地区
  handleChangeArea = hostArea => {
    const { gameStore } = this.props;
    // 切换动作
    this.setState({
      hostArea,
      province: 'all'
    });
    gameStore.filterGamesArea(hostArea);
    this.props.gameStore.currentGameId && this.props.gameStore.clearCurrentGameId();
  };

  handleChangeProvince = province => {
    const { gameStore } = this.props;
    // 切换动作
    this.setState({
      province
    });
    gameStore.filterGamesProvince(province);
    this.props.gameStore.currentGameId && this.props.gameStore.clearCurrentGameId();
  };

  render() {
    const { languageStore, gameStore } = this.props;
    const { v2categories, v2categoriesObj } = gameStore;

    const {
      categoryId,
      hostArea,
      province,
      translateCompetition,
      translateCountry,
      translateRegion
    } = this.state;

    const lang = languageStore.lang;
    // 
    const isChina =
    v2categoriesObj[categoryId] &&
    v2categoriesObj[categoryId].provinceList &&
    v2categoriesObj[categoryId].provinceList.length &&
      hostArea === '中国';
    return (
      <div className="filter--game-nav">
        <div className="select-group">
          {/* 比赛种类 */}
          <div className={`select-key ${lang === 'en' && 'en-lang'}`}>
            {translateCompetition[lang]}
          </div>
          <div className="select-values">
            {v2categories && v2categories.length
              ? v2categories.map(item => {
                  if ((v2categoriesObj[item.id]) && item.attributes.name) {
                    return (
                      <div
                        key={item.id}
                        className={`select-item ${categoryId === item.id &&
                          'active'}`}
                        onClick={() => {
                          this.handleChangeCategory(item.id);
                        }}
                      >
                        {item.attributes.name}
                      </div>
                    );
                  } else {
                    return null
                  }
                })
              : null}
          </div>
        </div>
        <div className="select-group-line"></div>
        
        <div className={`select-group ${isChina ? '' : 'hide-group'}`}>
          <div className={`select-key ${lang === 'en' && 'en-lang'}`}>
            {translateCountry[lang]}
          </div>
          <div className="select-values">
            {v2categoriesObj[categoryId] &&
            v2categoriesObj[categoryId].countryList &&
            v2categoriesObj[categoryId].countryList.length
              ? v2categoriesObj[categoryId].countryList.map(item => {
                  return (
                    <div
                      key={item.value}
                      className={`select-item ${hostArea === item.value &&
                        'active'}`}
                      onClick={() => {
                        this.handleChangeArea(item.value);
                      }}
                    >
                      {item.label}
                    </div>
                  );
                })
              : null}
          </div>
        </div>
        <div className={`select-group-line ${isChina ? 'show' : 'hide'}`}></div>
        {/* 省份筛选器，仅在中国下显示 */}
        <div className={`select-group-animation ${isChina ? 'show' : 'hide'}`}>
          <div className={`select-key ${lang === 'en' && 'en-lang'}`}>
            {translateRegion[lang]}
          </div>
          <div className="select-values">
            {v2categoriesObj[categoryId] &&
            v2categoriesObj[categoryId].provinceList &&
            v2categoriesObj[categoryId].provinceList.length
              ? v2categoriesObj[categoryId].provinceList.map(item => {
                  return (
                    <div
                      key={item.value}
                      className={`select-item ${province === item.value &&
                        'active'}`}
                      onClick={() => {
                        this.handleChangeProvince(item.value);
                      }}
                    >
                      {item.label}
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/game/filterNav.js